import { CamposSelect, ProjetosCamadasFormularios, ProjetosCamadasFormulariosCampo, Tabelas } from "../interfaces";

type Generic = Record<string, any>;

export const TABELAS_FORMULARIOS: Tabelas[] = [
  "lote",
  "imobiliario",
  "imobiliario_edificacao",
  "edificacao",
  "pessoa",
  "imobiliario_pessoa",
  "visitas",
  "mensagens",
  "midia",
];

function normalizeCampoSelect(option: Generic): CamposSelect {
  return {
    "@id": option?.["@id"] || option?.id || "",
    id: Number(option?.id ?? 0),
    projetoCamadaFormularioCampo: String(
      option?.projetoCamadaFormularioCampo ?? option?.projeto_camada_formulario_campo ?? "",
    ),
    fator: option?.fator ?? "",
    nome: option?.nome ?? "",
    ativo: option?.ativo ?? true,
    tblValorDb: String(option?.tblValorDb ?? option?.tbl_valor_db ?? option?.id ?? ""),
  };
}

function normalizeFormularioCampo(campo: Generic): ProjetosCamadasFormulariosCampo {
  return {
    "@id":
      campo?.["@id"] ||
      campo?.id_projetos_camadas_formularios_campos ||
      campo?.id_projetos_camadas_formularios_campos_old ||
      campo?.id ||
      "",
    audCriadoData: campo?.audCriadoData ?? campo?.aud_criado_data ?? "",
    audUsuarioCriou: campo?.audUsuarioCriou ?? campo?.aud_id_criado_por ?? "",
    audModificadoData: campo?.audModificadoData ?? campo?.aud_modificado_data ?? "",
    audUsuarioModificou: campo?.audUsuarioModificou ?? campo?.aud_id_modificado_por ?? "",
    id: Number(campo?.id ?? campo?.id_projetos_camadas_formularios_campos ?? 0),
    representacao: campo?.representacao ?? "",
    nome: campo?.nome ?? "",
    tipo: Number(campo?.tipo ?? 1),
    ativo: campo?.ativo ?? true,
    projetoCamadaFormulario: String(
      campo?.projetoCamadaFormulario ?? campo?.projeto_camada_formulario ?? campo?.id_projetos_camadas_formularios ?? "",
    ),
    obrigatorio: campo?.obrigatorio ?? false,
    projeto: String(campo?.projeto ?? campo?.id_projetos ?? ""),
    publicoOuv: campo?.publicoOuv ?? campo?.publico_ouv ?? false,
    ordem: Number(campo?.ordem ?? campo?.ordem_visualizacao ?? 0),
    tblNomeColuna: campo?.tblNomeColuna ?? campo?.tbl_nome_coluna ?? "",
    resumo: campo?.resumo ?? false,
    descricao: campo?.descricao ?? "",
    camposSelect: Array.isArray(campo?.camposSelect ?? campo?.selects)
      ? (campo.camposSelect ?? campo.selects).map(normalizeCampoSelect)
      : [],
    tipoCampo: String(campo?.tipoCampo ?? campo?.tipo ?? ""),
    caracterizacao: campo?.caracterizacao ?? false,
    somenteVisualizacao: campo?.somenteVisualizacao ?? campo?.somente_visualizacao ?? false,
    limiteCaracteres: campo?.limiteCaracteres ?? campo?.limite_caracteres,
    filtraCampo: campo?.filtraCampo ?? campo?.filtra_campo,
    colunaFiltroRetorno: campo?.colunaFiltroRetorno ?? campo?.coluna_filtro_retorno,
  };
}

export function normalizeFormulario(formulario: Generic, representacao: Tabelas): ProjetosCamadasFormularios {
  const camposRaw = Array.isArray(formulario?.projetosCamadasFormulariosCampos ?? formulario?.campos)
    ? (formulario.projetosCamadasFormulariosCampos ?? formulario.campos)
    : [];

  const campos = camposRaw.map(normalizeFormularioCampo);

  return {
    "@id":
      formulario?.["@id"] ||
      formulario?.id_projetos_camadas_formularios ||
      formulario?.id_projetos_camadas_formularios_old ||
      formulario?.id ||
      "",
    audCriadoData: formulario?.audCriadoData ?? formulario?.aud_criado_data ?? "",
    audUsuarioCriou: formulario?.audUsuarioCriou ?? formulario?.aud_id_criado_por ?? "",
    audModificadoData: formulario?.audModificadoData ?? formulario?.aud_modificado_data ?? "",
    audUsuarioModificou: formulario?.audUsuarioModificou ?? formulario?.aud_id_modificado_por ?? "",
    id: Number(formulario?.id ?? formulario?.id_projetos_camadas_formularios ?? 0),
    nome: formulario?.nome ?? "",
    projetoCamada: String(formulario?.projetoCamada ?? formulario?.id_projetos_camadas ?? ""),
    projeto: String(formulario?.projeto ?? formulario?.id_projetos ?? ""),
    projetosCamadasFormulariosCampos: campos,
    ativo: formulario?.ativo ?? true,
    representacao: representacao || formulario?.representacao || "",
    qtdObrigatorios: campos.filter((c) => c.obrigatorio).length,
    qtdOpcionais: campos.filter((c) => !c.obrigatorio).length,
    totalDeCampos: campos.length,
    podeExcluir: formulario?.podeExcluir ?? formulario?.pode_excluir ?? false,
  };
}

